import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_RAVEN_TRANSACTION_TYPE_DEF,
    ADD_RAVEN_TRANSACTION_TYPE_DEF,
    UPDATE_RAVEN_TRANSACTION_TYPE_DEF,
    DELETE_RAVEN_TRANSACTION_TYPE_DEF,
} from "./actionTypes"

import {
    getRavenTransactionTypeDefListSuccess,
    addRavenTransactionTypeDefSuccess,
    updateRavenTransactionTypeDefSuccess,
    deleteRavenTransactionTypeDefSuccess,
    apiRavenTransactionTypeDefApiError
} from "./actions"

// include backend helper file methods
import {
    getRavenTransactionTypeDefList,
    addRavenTransactionTypeDef,
    updateRavenTransactionTypeDef,
    deleteRavenTransactionTypeDef,
} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from "i18n";


  function* onGetRavenTransactionTypeDefList() {
    try {
      const response = yield call(getRavenTransactionTypeDefList)
      yield put(getRavenTransactionTypeDefListSuccess(response))
    } catch (error) {
      yield put(apiRavenTransactionTypeDefApiError(error))
    }
  }
  
  function* onAddRavenTransactionTypeDef({ payload: record }) {
    try {
      const response = yield call(addRavenTransactionTypeDef, record)
      yield put(addRavenTransactionTypeDefSuccess(response))
      toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
    } catch (error) {
      yield put(apiRavenTransactionTypeDefApiError(error))
    }
  }
  
  function* onUpdateRavenTransactionTypeDef({ payload: record }) {
    try {
      const response = yield call(updateRavenTransactionTypeDef, record)
      yield put(updateRavenTransactionTypeDefSuccess(response))
      toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
    } catch (error) {
      yield put(apiRavenTransactionTypeDefApiError(error))
    }
  }
  
  function* onDeleteRavenTransactionTypeDef({ payload: guid }) {
    try {
      const response = yield call(deleteRavenTransactionTypeDef, guid)
      yield put(deleteRavenTransactionTypeDefSuccess(response))
      toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
    } catch (error) {
      yield put(apiRavenTransactionTypeDefApiError(error))
    }
  }
  
  function* ravenTransactionTypeDefSaga() {

    yield takeEvery(GET_RAVEN_TRANSACTION_TYPE_DEF, onGetRavenTransactionTypeDefList)
    yield takeEvery(ADD_RAVEN_TRANSACTION_TYPE_DEF, onAddRavenTransactionTypeDef)
    yield takeEvery(UPDATE_RAVEN_TRANSACTION_TYPE_DEF, onUpdateRavenTransactionTypeDef)
    yield takeEvery(DELETE_RAVEN_TRANSACTION_TYPE_DEF, onDeleteRavenTransactionTypeDef)
  }
  
  export default ravenTransactionTypeDefSaga